import { render, staticRenderFns } from "./StandardSigUP.vue?vue&type=template&id=880ae3e0&"
import script from "./StandardSigUP.vue?vue&type=script&lang=js&"
export * from "./StandardSigUP.vue?vue&type=script&lang=js&"
import style0 from "./StandardSigUP.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports